import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/45_card_back_astrology/45_card_back_astrology"
 * Contains 1 texture(s)
 */
export class CardsBacks45CardBackAstrologyAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/45_card_back_astrology/45_card_back_astrology';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '45_astrology.png'
    ] as const;
}
